const LatestArticle = ({ article }) => {
  const { post_title, category, main_image, slug, summary } = article;

  const link = `/blog/${slug}`;
  const imageUrl = process.env.NEXT_PUBLIC_IMAGE_PATH + main_image;

  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-col gap-[24px] max-w-[445px]">
        <div className="lg:hidden max-w-[344px] overflow-hidden rounded-[5px]">
          <img className="w-full h-full object-cover" src={imageUrl} alt={post_title} />
        </div>

        <a href={link}>
          <h2 className="text-[32px] leading-[39px] font-[600]">{post_title}</h2>
        </a>
        <a href={link}>
          <p
            className="text-[16px] leading-[20px] font-normal"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2, // Limit to 2 lines
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {summary}
          </p>
        </a>

        <p
          className="border-1 text-[12px] leading-[14px] font-[600] px-[16px] py-[6px] rounded-[38px] max-w-min whitespace-nowrap"
          style={{ color: category.color, borderColor: category.color }}
        >
          {category.name}
        </p>

        <a href={link} className="flex w-full text-[#09AF77] hover:text-black text-[16px] font-[400] leading-[20px]  items-center gap-[10px]">
          Read More
          <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.230469 11.1336L4.61964 6.73486L0.230469 2.33611L1.58172 0.984863L7.33172 6.73486L1.58172 12.4849L0.230469 11.1336Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
      <div className="lg:flex hidden max-w-[635px] h-[400px] overflow-hidden rounded-[5px]">
        <img className="w-full h-full object-cover" src={imageUrl} alt={post_title} />
      </div>
    </div>
  );
};

export default LatestArticle;
